<span class="title">{{ title }}</span>
<div class="page-info"><mat-icon>info</mat-icon> <span [innerHtml]="pageInfo"></span></div>
<div class="dashboard">
  <cars-dashboard-sidebar [dashboardType]="dashboardType"></cars-dashboard-sidebar>
  <cars-dashboard-table [dashboardType]="dashboardType"></cars-dashboard-table>
</div>
